module.exports = __webpack_public_path__ + "static/media/map_docs.3632d394.md";


//////////////////
// WEBPACK FOOTER
// ./src/examples/map/map_docs.md
// module id = 992
// module chunks = 0